// extracted by mini-css-extract-plugin
module.exports = {"default":"Button--default--3kyEu"};